import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircleAlert, CircleCheck, Info, LoaderCircle, TriangleAlert } from "lucide-react";
import { cn } from "../lib/cn.js";
const toneClasses = {
    neutral: "bg-neutral-subtle text-foreground",
    success: "bg-success-subtle text-success",
    warning: "bg-warning-subtle text-warning",
    danger: "bg-danger-subtle text-destructive",
    info: "bg-info-subtle text-info",
};
/** Durum rozeti. Anlam YALNIZCA renkle taşınmaz: metin her zaman vardır (renk körlüğü, yüksek kontrast). */
export function StatusBadge({ tone = "neutral", children, className, }) {
    return (_jsxs("span", { className: cn("inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold", toneClasses[tone], className), children: [_jsx("span", { className: "size-1.5 rounded-full bg-current", "aria-hidden": "true" }), children] }));
}
const alertIcons = {
    neutral: Info,
    info: Info,
    success: CircleCheck,
    warning: TriangleAlert,
    danger: CircleAlert,
};
export function Alert({ tone = "info", title, children, className, }) {
    const Icon = alertIcons[tone];
    return (_jsxs("div", { role: tone === "danger" ? "alert" : "status", className: cn("flex gap-3 rounded-md p-3 text-sm", toneClasses[tone], className), children: [_jsx(Icon, { className: "mt-0.5 size-4 shrink-0", "aria-hidden": "true" }), _jsxs("div", { className: "grid gap-0.5", children: [title ? _jsx("p", { className: "font-semibold", children: title }) : null, children ? _jsx("div", { className: "text-foreground", children: children }) : null] })] }));
}
export function Skeleton({ className, ...props }) {
    return _jsx("div", { "aria-hidden": "true", className: cn("animate-pulse rounded-md bg-muted", className), ...props });
}
/** İskelet yükleyici: tablo/liste satırları. Ekran okuyucuya tek bir "yükleniyor" bildirimi gider. */
export function SkeletonRows({ rows = 5, label = "Yükleniyor", }) {
    return (_jsx("div", { role: "status", "aria-label": label, className: "grid gap-2", children: Array.from({ length: rows }, (_, index) => (_jsx(Skeleton, { className: "h-10 w-full" }, index))) }));
}
export function Spinner({ label = "Yükleniyor", className, }) {
    return (_jsx("span", { role: "status", "aria-label": label, className: cn("inline-flex", className), children: _jsx(LoaderCircle, { className: "size-5 animate-spin text-muted-foreground", "aria-hidden": "true" }) }));
}
export function EmptyState({ icon, title, description, action, className, headingLevel = 3, }) {
    const Heading = headingLevel === 2 ? "h2" : "h3";
    return (_jsxs("div", { className: cn("flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed px-6 py-12 text-center", className), children: [icon ? (_jsx("div", { className: "flex size-12 items-center justify-center rounded-full bg-muted text-muted-foreground [&_svg]:size-6", "aria-hidden": "true", children: icon })) : null, _jsxs("div", { className: "grid gap-1", children: [_jsx(Heading, { className: "text-base font-semibold", children: title }), description ? _jsx("p", { className: "max-w-md text-sm text-muted-foreground", children: description }) : null] }), action] }));
}
export function Card({ className, ...props }) {
    return (_jsx("section", { className: cn("rounded-lg border bg-card text-card-foreground shadow-card", className), ...props }));
}
//# sourceMappingURL=feedback.js.map